import PropTypes from 'prop-types';
import Translated from '../Translated';
import Button from 'react-bootstrap/Button'

const FullTestContinue = (props) => {
  return (
    <div id="full-test-continue-container" className="max-width-container centered">
      <div className="blue-box">
        <h3>
          <Translated translationKey="fulltest_continue" />
        </h3>
        <div className="centered">
          <br />
          <Button id="full-test-start-new" onClick={props.onRestart} bsstyle="info">
            <Translated translationKey="no" />
          </Button>&nbsp;&nbsp;&nbsp;
          <Button id="full-test-continue" onClick={props.onRestore}>
            <Translated translationKey="yes" />
          </Button>
        </div>
      </div>
    </div>
  );
}

FullTestContinue.propTypes = {
  onRestart: PropTypes.func.isRequired,
  onRestore: PropTypes.func.isRequired
}

export default FullTestContinue;
